import type React from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useAppNavigation from '../../../hooks/useAppNavigation';
import type { AppSsrFetchedDataType } from '../../../server/AppSsr';
import TiersSection from './TiersSection';

interface PricesProps {
  ssrFetchedData: AppSsrFetchedDataType;
}

const Prices: React.FC<PricesProps> = ({ ssrFetchedData }) => {
  const { t } = useTranslation();
  const { navigate } = useAppNavigation();

  const onBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <div className="min-w-full min-h-screen flex flex-col items-center jsutify-center bg-slate-50">
      <div className="min-w-full flex flex-col items-center justify-center grow gap-3">
        <div className="flex flex-row">
          <TiersSection ssrFetchedData={ssrFetchedData} />
        </div>
      </div>
    </div>
  );
};

export default Prices;
